import React, { useEffect } from "react";
import HomeStyle from "./../../Style/Home.module.css";
import HeadingAbout from "./../HeadingAbout/HeadingAbout";
import Service from "./../Service/Service";
import Blog from "./../Blog/Blog";
import Dash from "./../Dash/Dash";
import Footer from "./../Footer/Footer";
import Aos from "aos";
import "aos/dist/aos.css";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import Project from "../Project/Project";
import Members from "../Members/Members";
export default function Home() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <>
      <header className="vh-100 mb-5 mt-5  py-5" data-aos="fade-up" id="home">
        <div className="container margin1 py-5 h-100 d-flex align-items-center">
          <div className="">
            <div className="row g-2">
              <div className="col-md-6 mt-5 ">
                <div className="">
                  <div className={HomeStyle.item_header + " my-5"}>
                    <img src="./img/UBTC.png" alt="" className="w-100"/>
                    <h1 className={HomeStyle.h1 + " mb-5"}>
                      {" "}
                      <span className={HomeStyle.header_span}>
                        Construction
                      </span>{" "}
                      you can count on.
                    </h1>
                  </div>

                  <p className={HomeStyle.header_desc + " my-5"}>
                    <ul className="listHeader">
                      <li> One of the most upgrading and promising companies in Egypt</li>
                      <li>In February 2010, UBTC was established as an Egyptian joint-stock company subject to 
the companies' establishment law no.159 for the year 1981. UBTC was established 
with an authorized capital of 10 millions Egyptian pounds.</li>
                    </ul>
                  </p>
                  <div className="row">
                    <div className="col-md-8 col-sm-12">

                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div>
                  <img src="./img/pngwing.png" alt="img" className="w-100" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <HeadingAbout />
      <Service />
      <Project />
      {/* <Members/> */}
      {/* <Blog /> */}
      <Footer />
    </>
  );
}
